// extracted by mini-css-extract-plugin
export default {"wrapper":"AssignToTeamModal_wrapper__2bFA-","formWrapper":"AssignToTeamModal_formWrapper__31pvO","buttonGroup":"AssignToTeamModal_buttonGroup__2KB3q"};